/**
 * @generated SignedSource<<285be8bc85d8b1d6405b29a405b9aeca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type searchablePublishedRootTable_QueryFragment$data = {
  readonly Admin: {
    readonly LearnV2: {
      readonly SearchLearnOpportunityV2: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"searchablePublishedRootTable_LearnOpportunityV2Fragment">;
          };
        } | null> | null;
      };
    };
  };
  readonly " $fragmentType": "searchablePublishedRootTable_QueryFragment";
};
export type searchablePublishedRootTable_QueryFragment$key = {
  readonly " $data"?: searchablePublishedRootTable_QueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchablePublishedRootTable_QueryFragment">;
};

import searchablePublishedRootTable_QueryRefetch_graphql from './searchablePublishedRootTable_QueryRefetch.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "Admin",
  "LearnV2",
  "SearchLearnOpportunityV2"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "titleMatchRegex"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": searchablePublishedRootTable_QueryRefetch_graphql
    }
  },
  "name": "searchablePublishedRootTable_QueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminQueryType",
      "kind": "LinkedField",
      "name": "Admin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LearnV2AdminSchema",
          "kind": "LinkedField",
          "name": "LearnV2",
          "plural": false,
          "selections": [
            {
              "alias": "SearchLearnOpportunityV2",
              "args": [
                {
                  "kind": "Variable",
                  "name": "titleMatchRegex",
                  "variableName": "titleMatchRegex"
                }
              ],
              "concreteType": "LearnOpportunitiesV2Connection",
              "kind": "LinkedField",
              "name": "__searchablePublishedRootTable_SearchLearnOpportunityV2_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LearnOpportunitiesV2Edge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LearnOpportunityV2",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "searchablePublishedRootTable_LearnOpportunityV2Fragment",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "id",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "structureDefinition",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "title",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "args": null,
                          "argumentDefinitions": []
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "74828583f359763721b27c3b82d5ab4d";

export default node;
